import { allSymbolsAndEnglishLettersRegex, mailRegex } from 'constants/regex'
import { UserRoles } from 'constants/roles'
import { PAYMENT_INFORMATION_FORM_VALUES } from 'texts/profileDetails'
import { FormValuesSetting } from 'types/form'

export const paymentInformationFormValuesSetting: FormValuesSetting = {
  legalName: {
    required: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: true,
    },
    disabled: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: false,
    },
    validationRules: [
      {
        type: 'required',
        message: PAYMENT_INFORMATION_FORM_VALUES.LEGAL_NAME.REQUIRED_MESSAGE,
      },
      {
        type: 'pattern',
        value: allSymbolsAndEnglishLettersRegex,
        message: PAYMENT_INFORMATION_FORM_VALUES.LEGAL_NAME.VALIDATION_MESSAGE,
      },
    ],
  },
  registrationNumber: {
    required: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: true,
    },
    disabled: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: false,
    },
    validationRules: [
      {
        type: 'required',
        message:
          PAYMENT_INFORMATION_FORM_VALUES.REGISTRATION_NUMBER.REQUIRED_MESSAGE,
      },
      {
        type: 'pattern',
        value: allSymbolsAndEnglishLettersRegex,
        message:
          PAYMENT_INFORMATION_FORM_VALUES.REGISTRATION_NUMBER
            .VALIDATION_MESSAGE,
      },
    ],
  },
  swift: {
    required: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: true,
    },
    disabled: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: false,
    },
    validationRules: [
      {
        type: 'required',
        message: PAYMENT_INFORMATION_FORM_VALUES.SWIFT.REQUIRED_MESSAGE,
      },
      {
        type: 'pattern',
        value: allSymbolsAndEnglishLettersRegex,
        message: PAYMENT_INFORMATION_FORM_VALUES.SWIFT.VALIDATION_MESSAGE,
      },
    ],
  },
  iban: {
    required: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: true,
    },
    disabled: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: false,
    },
    validationRules: [
      {
        type: 'required',
        message: PAYMENT_INFORMATION_FORM_VALUES.IBAN.REQUIRED_MESSAGE,
      },
      {
        type: 'pattern',
        value: allSymbolsAndEnglishLettersRegex,
        message: PAYMENT_INFORMATION_FORM_VALUES.IBAN.VALIDATION_MESSAGE,
      },
    ],
  },
  bankName: {
    required: {
      [UserRoles.Supplier]: false,
      [UserRoles.Operator]: false,
    },
    disabled: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: false,
    },
    validationRules: [
      {
        type: 'pattern',
        value: allSymbolsAndEnglishLettersRegex,
        message: PAYMENT_INFORMATION_FORM_VALUES.BANK_NAME.VALIDATION_MESSAGE,
      },
    ],
  },
  vat: {
    required: {
      [UserRoles.Supplier]: false,
      [UserRoles.Operator]: false,
    },
    disabled: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: false,
    },
    validationRules: [
      {
        type: 'required',
        message: PAYMENT_INFORMATION_FORM_VALUES.VAT.REQUIRED_MESSAGE,
      },
      {
        type: 'pattern',
        value: allSymbolsAndEnglishLettersRegex,
        message: PAYMENT_INFORMATION_FORM_VALUES.VAT.VALIDATION_MESSAGE,
      },
    ],
  },
  currency: {
    required: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: true,
    },
    disabled: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: false,
    },
    validationRules: [
      {
        type: 'required',
        message: PAYMENT_INFORMATION_FORM_VALUES.CURRENCY.REQUIRED_MESSAGE,
      },
    ],
  },
  bankAddress: {
    required: {
      [UserRoles.Supplier]: false,
      [UserRoles.Operator]: false,
    },
    disabled: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: false,
    },
    validationRules: [
      {
        type: 'pattern',
        value: allSymbolsAndEnglishLettersRegex,
        message:
          PAYMENT_INFORMATION_FORM_VALUES.BANK_ADDRESS.VALIDATION_MESSAGE,
      },
    ],
  },
  aba: {
    required: {
      [UserRoles.Supplier]: false,
      [UserRoles.Operator]: false,
    },
    disabled: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: false,
    },
    validationRules: [
      {
        type: 'pattern',
        value: allSymbolsAndEnglishLettersRegex,
        message: PAYMENT_INFORMATION_FORM_VALUES.ABA.VALIDATION_MESSAGE,
      },
    ],
  },
  accountingEmail: {
    required: {
      [UserRoles.Supplier]: false,
      [UserRoles.Operator]: false,
    },
    disabled: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: false,
    },
    validationRules: [
      {
        type: 'pattern',
        value: mailRegex,
        message: PAYMENT_INFORMATION_FORM_VALUES.EMAIL.VALIDATION_MESSAGE,
      },
      {
        type: 'min',
        value: 5,
        message: PAYMENT_INFORMATION_FORM_VALUES.EMAIL.VALIDATION_MESSAGE,
      },
    ],
  },
}
